<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('affiliateCommissionManage.queryCondition') }}</span>
      </div>
      <el-form :inline="true" class="demo-form-inline text-left">
        <el-form-item>
          <el-input
            v-model="affiliateCommissionManageInfo.conditions.commissionRate"
            :placeholder="$t('affiliateCommissionManage.selectCommissionRate')"
            clearable
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="_queryAffiliateCommissionMethod">
            {{ $t('affiliateCommissionManage.query') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card style="margin-top: 20px;">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('affiliateCommissionManage.affiliateOrder') }}</span>
      </div>
      <el-table
        :data="affiliateCommissionManageInfo.affiliateCommissions"
        border
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column prop="acId" :label="$t('affiliateCommissionManage.commissionId')" align="center" />
        <el-table-column prop="auName" :label="$t('affiliateCommissionManage.affiliateId')" align="center" />
        <el-table-column prop="orderId" :label="$t('affiliateCommissionManage.relatedOrderId')" align="center" />
        <el-table-column prop="orderItemId" :label="$t('affiliateCommissionManage.orderItemId')" align="center" />
        <el-table-column prop="userName" :label="$t('affiliateCommissionManage.orderUserId')" align="center" />
        <el-table-column :label="$t('affiliateCommissionManage.relationLevel')" align="center">
          <template #default="{row}">
            {{ _level(row.relationLevel) }}
          </template>
        </el-table-column>
        <el-table-column prop="commissionRate" :label="$t('affiliateCommissionManage.commissionRate')" align="center" />
        <el-table-column prop="orderAmount" :label="$t('affiliateCommissionManage.orderAmount')" align="center" />
        <el-table-column prop="commissionAmount" :label="$t('affiliateCommissionManage.commissionAmount')" align="center" />
        <el-table-column :label="$t('affiliateCommissionManage.status')" align="center">
          <template #default="{row}">
            {{ _state(row.state) }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('affiliateCommissionManage.createTime')" align="center" />
        <el-table-column prop="settlementTime" :label="$t('affiliateCommissionManage.settlementTime')" align="center" />
        <el-table-column prop="remark" :label="$t('affiliateCommissionManage.remark')" align="center" />
        <el-table-column :label="$t('affiliateCommissionManage.operation')" align="center" width="180">
          <template #default="{row}">
            <el-button size="mini" @click="_openEditAffiliateCommissionModel(row)">
              {{ $t('affiliateCommissionManage.edit') }}
            </el-button>
            <el-button size="mini" type="danger" @click="_openDeleteAffiliateCommissionModel(row)">
              {{ $t('affiliateCommissionManage.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="affiliateCommissionManageInfo.conditions.page"
        :page-size="affiliateCommissionManageInfo.conditions.row"
        layout="total, prev, pager, next, jumper"
        :total="affiliateCommissionManageInfo.total"
        style="margin-top: 20px; text-align: right;"
      />
    </el-card>

    <delete-affiliate-commission ref="deleteAffiliateCommission"></delete-affiliate-commission>
  </div>
</template>

<script>
import { listAffiliateCommission } from '@/api/affiliate/affiliateCommissionApi'
import DeleteAffiliateCommission from '@/components/affiliate/deleteAffiliateCommission/deleteAffiliateCommission'

export default {
  name: 'AffiliateCommissionManage',
  components: {
    DeleteAffiliateCommission
  },
  data() {
    return {
      loading: false,
      affiliateCommissionManageInfo: {
        affiliateCommissions: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          commissionRate: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listAffiliateCommissions(1, 10)
  },
  methods: {
    async _listAffiliateCommissions(page, rows) {
      this.loading = true
      this.affiliateCommissionManageInfo.conditions.page = page
      this.affiliateCommissionManageInfo.conditions.row = rows
      
      try {
        const res = await listAffiliateCommission(this.affiliateCommissionManageInfo.conditions)
        this.affiliateCommissionManageInfo.total = res.total
        this.affiliateCommissionManageInfo.records = res.records
        this.affiliateCommissionManageInfo.affiliateCommissions = res.data
      } catch (error) {
        console.error('请求失败:', error)
      } finally {
        this.loading = false
      }
    },
    handleCurrentChange(val) {
      this._listAffiliateCommissions(val, this.affiliateCommissionManageInfo.conditions.row)
    },
    _openEditAffiliateCommissionModel(row) {
      console.log(row)
      // 这里需要实现编辑逻辑
    },
    _openDeleteAffiliateCommissionModel(row) {
      this.$refs.deleteAffiliateCommission.open(row)
    },
    _queryAffiliateCommissionMethod() {
      this._listAffiliateCommissions(1, this.affiliateCommissionManageInfo.conditions.row)
    },
    _level(state) {
      if (state == "1") return this.$t('affiliateCommissionManage.level1')
      if (state == "2") return this.$t('affiliateCommissionManage.level2')
      return state
    },
    _state(state) {
      if (state == "0") return this.$t('affiliateCommissionManage.state0')
      if (state == "1") return this.$t('affiliateCommissionManage.state1')
      if (state == "2") return this.$t('affiliateCommissionManage.state2')
      return state
    }
  }
}
</script>

<style scoped>
/* 使用 el-card 样式，无需自定义样式 */
</style>